import { render, staticRenderFns } from "./DoubleRow.vue?vue&type=template&id=5996b36e&scoped=true&"
import script from "./DoubleRow.vue?vue&type=script&lang=ts&"
export * from "./DoubleRow.vue?vue&type=script&lang=ts&"
import style0 from "./DoubleRow.vue?vue&type=style&index=0&id=5996b36e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996b36e",
  null
  
)

export default component.exports